import { Box } from '@material-ui/core';
import { Layer, Stage } from 'react-konva';
import React, { forwardRef, useContext } from 'react';
import { getOuterGroundColor } from '../../models/ground';
import { Pitch } from '../track/ground/Ground';
import PlayersLinks from './PlayersLinks';
import PlayersMarkers from './PlayersMarkers';
import ZoomControls from './ZoomControls';
import { GroundFieldData, GroundFieldProps } from '../../types/webPlayer';
import { PlayersTeamsContext } from './WebPlayer';
import { usePlayerStageContext } from './VideoPlayerContext';

const GroundField = forwardRef<HTMLDivElement, GroundFieldProps & GroundFieldData>((props, parentRef) => {
  const {
    activePlayer,
    bearing,
    hoverPlayer,
    children,
    cursor,
    defaultPlayersColor,
    dataGround,
    enabledPlayers,
    groundGeometry,
    infoPlayers,
    jerseyOrNumber,
    offX,
    offY,
    onPlayerClick,
    onPlayerDblClick,
    onPlayerEnter,
    onPlayerLeave,
    playersColors,
    playersDetails,
    playersLines,
    playersPoints,
    removeLink,
    scale,
    series,
    setZoom,
    showVertices,
    teamColors,
    trailsEnabled,
    userUnits,
    WINDOW_WIDTH,
    WINDOW_HEIGHT,
    zoom,
  } = props;

  const { playersTeams } = useContext(PlayersTeamsContext);
  const playerStageRef = usePlayerStageContext();

  return (
    <Box width="100%">
      <Box display="flex" justifyContent="center" width="100%">
        <Box
          bgcolor={getOuterGroundColor(dataGround?.groundSurfaceColor)}
          position="relative"
          width="100%"
        >
          <div
            className="player__wrapper"
            ref={parentRef}
            style={{
              width: '100%',
              height: 'auto',
              aspectRatio: '16/9',
            }}
          >
            <Stage
              id="container"
              offsetX={offX}
              offsetY={offY}
              draggable
              width={WINDOW_WIDTH}
              height={WINDOW_HEIGHT}
              scaleX={zoom}
              scaleY={zoom}
              ref={playerStageRef}
            >
              <Layer listening={false} id="layer-pitch">
                {
                  groundGeometry && (
                    <Pitch
                      defaultGround={false}
                      groundData={dataGround}
                      groundGeometry={groundGeometry}
                      scale={scale}
                      vertices={showVertices}
                    />
                  )
                }
              </Layer>

              {
                playersLines
                && removeLink
                && (
                  <PlayersLinks
                    playersLines={playersLines}
                    removeLink={removeLink}
                    groundSurfaceColor={dataGround?.groundSurfaceColor}
                    scale={scale}
                  />
                )
              }

              {
                !!(enabledPlayers
                && onPlayerClick
                && playersDetails
                && series
                && playersColors)
                && (
                  <PlayersMarkers
                    activePlayer={activePlayer || null}
                    bearing={bearing || 0}
                    hoverPlayer={hoverPlayer || null}
                    cursor={cursor}
                    dataGround={dataGround}
                    defaultPlayersColor={defaultPlayersColor}
                    enabledPlayers={enabledPlayers}
                    groundSurfaceColor={dataGround?.groundSurfaceColor}
                    infoPlayers={infoPlayers}
                    jerseyOrNumber={!!jerseyOrNumber}
                    onPlayerClick={onPlayerClick}
                    onPlayerDblClick={onPlayerDblClick}
                    onPlayerEnter={onPlayerEnter}
                    onPlayerLeave={onPlayerLeave}
                    playersColors={playersColors}
                    playersDetails={playersDetails}
                    playersPoints={playersPoints}
                    scale={scale}
                    series={series}
                    teamColors={teamColors}
                    trailsEnabled={!!trailsEnabled}
                    userUnits={userUnits}
                    playersTeams={playersTeams}
                  />
                )
              }

              {children}
            </Stage>

            <ZoomControls setZoom={setZoom} zoom={zoom} />
          </div>
        </Box>
      </Box>
    </Box>
  );
});

export default GroundField;
